import React from "react";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import { FilledIconButton } from "../Components/FilledIconButton";

function CalendarButton() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div>
      <Tooltip title={t("common.buttons.calendar")}>
        <FilledIconButton
          size="medium"
          component={Link}
          to={{ pathname: "/scheduler" }}
          icon={<CalendarTodayIcon fontSize="small" />}
          bgcolor={theme.palette.background.paper}
        />
      </Tooltip>
    </div>
  );
}

export default CalendarButton;
